import React from "react";

type ZePartnerItemProps = {
  name: string;
  img: string;
  link: string;
};

const ZePartnerItem: React.FC<ZePartnerItemProps> = ({ name, img, link }) => {
  return (
    <a className="zefi-partner-logo" href={link} target="_blank">
      <img
        src={img}
        alt={name}
        style={{
          maxWidth: "100px",
          height: "auto",
        }}
      />
      <p className="mt-2">{name}</p>
    </a>
  );
};

export default ZePartnerItem;
